import React from 'react';
import { type Value, Select, SIZE, TYPE } from 'baseui/select';
import { searchInputOverrides } from './styled-component-overrides';
type SearchBarProps = {
  placeholder: string;
  onChange: (value: string) => void;
  options: Value;
  currentValueIndex: number;
};
export const SearchBar = ({
  placeholder,
  onChange,
  options,
  currentValueIndex
}: SearchBarProps) => {
  return <Select size={SIZE.mini} placeholder={placeholder} overrides={searchInputOverrides} type={TYPE.search} options={options} onChange={({
    value
  }) => {
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    onChange((value[0].id as string));
  }}
  // @ts-expect-error todo(ts-migration) TS2322 Type 'Readonly<{ [x: string]: any; id?: string | number | undefined; label?: ReactNode; disabled?: boolean | undefined; clearableValue?: boolean | undefined; isCreatable?: boolean | undefined; __optgr...
  value={[options[currentValueIndex]]} clearable={false} />;
};